import { DataType } from './eDataType';
import { ServiceLocator } from '../ServiceLocator';


export class EntityField {
    Name: string;
    Alias: string;
    Value: string;
    Display: string;
    Type: DataType;
    TypeInt: number;
    FamilyId: string;

    constructor(name: string = "", value: string = "", type: DataType = DataType.VARCHAR2) {
        this.Name = name;
        this.Alias = name;
        this.Value = value;
        this.Display = "";
        this.Type = type;
        this.FamilyId = "";
    }
}